export interface TraceContext {
  traceparent: string;
  trace_id: string;
  span_id: string;
}

function randomHex(bytes: number): string {
  return Array.from(crypto.getRandomValues(new Uint8Array(bytes)))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function generateTraceContext(): TraceContext {
  const trace_id = randomHex(16);
  const span_id = randomHex(8);
  return { traceparent: `00-${trace_id}-${span_id}-01`, trace_id, span_id };
}
